import React from "react";
import PropTypes from "prop-types";

const ToggleSwitch = ({ toggleSwitch, handleSwitch }) => {
  return (
    <>
      {toggleSwitch ? (
        <img
          onClick={handleSwitch}
          src="/images/enableSwitch.svg"
          className="cursor-pointer"
          alt="enable switch"
        />
      ) : (
        <img
          onClick={handleSwitch}
          src="/images/disableSwitch.svg"
          className="cursor-pointer"
          alt="disable switch"
        />
      )}
    </>
  );
};
ToggleSwitch.propTypes = {
  toggleSwitch: PropTypes.bool,
  handleSwitch: PropTypes.func
};
export default ToggleSwitch;
